import { useState } from 'react';
import { Sparkle, Copy } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { streamAI } from '../../lib/aiStream';
import { AiText } from './AiText';

const PLATFORMS = ['Shopee', 'Tokopedia', 'TikTok Shop', 'WhatsApp / Instagram'];

export const AiProductDialog = ({ product, mode, onClose }) => {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [platform, setPlatform] = useState('Shopee');
  const [catatan, setCatatan] = useState('');
  const isDesc = mode === 'description';

  const run = async () => {
    setLoading(true);
    setText('');
    try {
      const path = isDesc ? `/ai/description/${product.id}` : `/ai/pricing/${product.id}`;
      await streamAI(path, isDesc ? { platform, catatan } : {}, setText);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const copy = async () => {
    await navigator.clipboard.writeText(text.replace(/\*\*/g, ''));
    toast.success('Teks disalin');
  };

  return (
    <Dialog open={!!product} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="ai-product-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <Sparkle size={20} weight="duotone" className="text-primary" />
            {isDesc ? 'Tulis Deskripsi Produk' : 'Saran Harga AI'} · {product?.nama}
          </DialogTitle>
          <DialogDescription>
            {isDesc ? 'Deskripsi siap tempel untuk listing marketplace. Periksa lagi sebelum dipakai.' : 'Claude membaca HPP, komponen biaya, potongan dan penjualan produk ini.'}
          </DialogDescription>
        </DialogHeader>

        {isDesc && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label className="block space-y-1.5">
              <span className="text-sm font-medium text-muted-foreground">Platform</span>
              <select value={platform} onChange={(e) => setPlatform(e.target.value)} data-testid="ai-desc-platform"
                className="w-full px-3 py-2 bg-background border border-border rounded-lg">
                {PLATFORMS.map((p) => <option key={p}>{p}</option>)}
              </select>
            </label>
            <label className="block space-y-1.5">
              <span className="text-sm font-medium text-muted-foreground">Catatan (opsional)</span>
              <input value={catatan} onChange={(e) => setCatatan(e.target.value)} placeholder="mis. pedas level 3, tahan 3 bulan di freezer" data-testid="ai-desc-catatan"
                className="w-full px-3 py-2 bg-background border border-border rounded-lg" />
            </label>
          </div>
        )}

        <div className="flex gap-2">
          <button onClick={run} disabled={loading} data-testid="btn-ai-generate"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary text-primary-foreground text-sm font-medium disabled:opacity-60">
            <Sparkle size={16} weight="fill" /> {loading ? 'Menulis…' : text ? 'Buat Ulang' : isDesc ? 'Tulis Deskripsi' : 'Minta Saran'}
          </button>
          {text && !loading && (
            <button onClick={copy} data-testid="btn-ai-copy" className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border text-sm hover:bg-secondary">
              <Copy size={16} /> Salin
            </button>
          )}
        </div>

        {(text || loading) && (
          <div className="bg-secondary/40 rounded-lg p-4 border border-border/60">
            {text ? <AiText text={text} testid="ai-product-text" /> : <div className="h-4 w-1/2 rounded bg-secondary animate-pulse" />}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
